import {Routes,Route,Router} from "react-router-dom"
import NavBar from "./components/NavBar/NavBar";
import SideBar from "./components/SideBar";
import RequireAuth from "./components/RequireAuth/RequireAuth";
import About from "./components/About";
import Timeoffs from "./components/Timeoff/Timeoff";
import PTOReqReports from "./components/Pages/PTOReports";
import Reports from "./components/PayReports/Reports";
import Summary from "./components/Pages/Summary";
import AddUser from "./components/AddUser/AddUser";
import EditUser from "./components/EditUser/EditUser";
import Transact from "./components/Transact/Transact";
import DeleteUser from "./components/DeleteUser/DeleteUser";
import Home from "./components/Home";
import Compensation from "./components/Pages/Compensation";
import Settings from "./components/Settings/Settings";
import AdvanceReports from "./components/Pages/AdvanceReports";
import PTOReports from "./components/Timeoff/Timeoff";
import Login from "./components/Login/Login";
import Recovery from "./components/Recovery/Recovery";
import PersistLogin from "./components/PersistLogin/PersistLogin";
import Landing from "./components/Pages/Landing/Landing";
import PayrollPage from "./components/Pages/Payroll/Payroll/Payroll";


{/* <Route path="Support" element={<Settings/>}/>  
<Route path="AddUser" element={<AddUser/>}/>  
<Route path="EditUser" element={<EditUser/>}/>  
<Route path="Reports" element={<Reports/>}/>  
<Route path="Transact" element={<Transact/>}/>  
<Route path="AdvanceReports" element={<AdvanceReports/>}/>  
<Route path="PTORequest" element={<PTOReports/>}/>  
<Route path="DeleteUser" element={<DeleteUser/>}/>   */}




// import "./AppWhole.css"




function App() {

    const ROLES = {
        "admin" :"admin",
        "user" :"user",
      }

    return <>

<Routes>
                     {/* PUBLIC */}
                      {/* <Route path="/" element={<Reports/>}> */}
                      <Route path="/login" element={<Login/>}>

                      </Route>
                      <Route path="/" element={<Landing/>}>

                      </Route>
                      <Route path="/pr" element={<PayrollPage/>}>

                      </Route>
                      <Route path="/Recovery/:token" element={<Recovery/>}>

                      </Route>
                    <Route element={<PersistLogin />}>
                      <Route element={<RequireAuth allowedRoles={[ROLES.user,ROLES.admin]} />}>
                          <Route path="/Dashboard" element={<SideBar />}> 

                           <Route index element={<Compensation/>}>

                           </Route>
                                
                              <Route path="about" element={<About />}/>
                              {/* <Route index element={<Summary />}/> */}
                              <Route path="Summary" element={<Summary />}/>
                              <Route path="Support" element={<Settings />}/>
                               
                            
                              {/* <Route path="Compensation" element={<Compensation/>}/> */}
                              <Route path="PTORequest" element={<PTOReqReports />}/>
                              <Route path="Timeoffs" element={<Timeoffs />}/>
                              
                                  
                              <Route path="PTOReports" element={<PTOReports />}/>
                              <Route path="Support" element={<Settings/>}/>  
                              <Route path="AddUser" element={<AddUser/>}/>  
                              <Route path="EditUser" element={<EditUser/>}/>  
                              <Route path="Reports" element={<Reports/>}/>  
                              <Route path="Transact" element={<Transact/>}/>  
                              <Route path="AdvanceReports" element={<AdvanceReports/>}/>  
                              {/* <Route path="PTOReports" element={<PTOReports/>}/>   */}
                              <Route path="DeleteUser" element={<DeleteUser/>}/>  
                                  

                          </Route>  
                      </Route>

                      </Route>

                   
                    
                      
                         
                  </Routes> 

          {/* <div className="wholeApp">

                <NavBar />
                <Login/>

                <div>
                    <div className="fixedSide">
                        <SideBar/>
                    </div>
                    

                    <Routes>
                   
                        <Route index path="/Com" element={<Home />}>
                                
                        </Route> 

                              <Route path="about" element={<About />}>
                                
                              </Route>
                              <Route path="/Timeoffs" element={<Timeoffs />}>
                                
                              </Route>

                              <Route path="/PTOReports" element={<PTOReports />}>
                                
                                </Route>

                              <Route path="/Login" element={<Login />}>
                          
                          </Route>

                        
                    </Routes> 

                </div>

          </div> */}

    </>;
  } 


  export default App;
  